module.exports = __webpack_public_path__ + "img/02.4798aff2.jpg";